var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 517.88889 454.55554",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M208.5668,258.66666H309.32208a11.40015,11.40015,0,0,1,11.40015,11.40014h0V415.6163A24.49369,24.49369,0,0,1,296.22858,440.11H221.66032a24.49367,24.49367,0,0,1-24.49366-24.49369h0V270.0668a11.40014,11.40014,0,0,1,11.40013-11.40014Z",
    fill: "#798f9e"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M499.38889,228.44444,290.3269,41.22475a44.48793,44.48793,0,0,0-58.773-.51432L18.5,224.88889",
    fill: "none",
    stroke: "#798f9e",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 37
  }), /*#__PURE__*/React.createElement("path", {
    d: "M435.38889,171.131V417.7778a17.77777,17.77777,0,0,1-17.77774,17.77774h-312.889A17.77775,17.77775,0,0,1,86.94444,417.7778V171.131",
    fill: "none",
    stroke: "#798f9e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 38
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.34457,0H428.4332a6.95569,6.95569,0,0,1,6.95569,6.95569V146.05638H386.34457a6.95568,6.95568,0,0,1-6.95568-6.95569V6.95569A6.95568,6.95568,0,0,1,386.34457,0Z",
    fill: "#798f9e"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.c677f992056fc9e19de08f7ee884041e.svg";
export { ForwardRef as ReactComponent };